// src/components/Destinations.js
import React from 'react';

const Destinations = () => {
  return (
    <div>
      <h2>Popular Destinations</h2>
      <ul>
        <li>Colombo</li>
        <li>Kandy</li>
        <li>Galle</li>
        <li>Ella</li>
        <li>Sigiriya</li>
      </ul>
    </div>
  );
};

export default Destinations;
